import { useQueryClient } from '@tanstack/react-query';
import { supportTicketServices } from '../services/support-ticket.service';

export const usePrefetchSupportTickets = () => {
  const queryClient = useQueryClient();

  const prefetchNextPage = (currentFilters, totalPages) => {
    const nextPage = parseInt(currentFilters.page) + 1;
    if (nextPage <= totalPages) {
      queryClient.prefetchQuery({
        queryKey: ['support-tickets', { ...currentFilters, page: String(nextPage) }],
        queryFn: () =>
          supportTicketServices.getSupportTickets({
            ...currentFilters,
            page: String(nextPage),
          }),
        staleTime: 5 * 60 * 1000,
      });
    }
  };

  const prefetchPrevPage = (currentFilters) => {
    const prevPage = parseInt(currentFilters.page) - 1;
    if (prevPage >= 1) {
      queryClient.prefetchQuery({
        queryKey: ['support-tickets', { ...currentFilters, page: String(prevPage) }],
        queryFn: () =>
          supportTicketServices.getSupportTickets({
            ...currentFilters,
            page: String(prevPage),
          }),
        staleTime: 5 * 60 * 1000,
      });
    }
  };

  return { prefetchNextPage, prefetchPrevPage };
};
